/**
 * 白底折线图
 * @param unit 单位
 * @param type 折线/柱状
 * @param xData []x轴数据
 * @param dataArr [{name:'',data:[]}]y轴数据合集
 */
import { dealBigNum } from "@/assets/js/utils";
import router from "@/router";
export function setOption(paramObj) {
  let option = {
    grid: {
      top: "60px",
      left: "80px",
      right: "15px",
      bottom: "30px",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    legend: {
      type: "scroll",
      top: "1%",
      right: "2%",
      textStyle: {
        color: "#333",
        fontSize: 12,
      },
    },
    xAxis: {
      type: "category",
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: "#CBCBCB",
        fontSize: 12,
      },
      data: paramObj.xData,
    },
    yAxis: {
      type: "value",
      name: paramObj.unit ? `单位(${paramObj.unit})` : "",
      nameTextStyle: {
        color: "#666",
        fontSize: 12,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },

      axisLabel: {
        color: "#999",
        fontSize: 12,
      },
      splitLine: {
        lineStyle: {
          type: "solid",
          color: "#EBEBEB",
        },
      },
    },
    dataZoom: [
      {
        type: "inside",
      },
    ],
    series: [],
  };
  paramObj.dataArr.forEach((v, i) => {
    option.series.push({
      name: v.name,
      data: v.data,
      type: paramObj.type ?? "line",
      symbolSize: v.name == "国家指标" || v.name == "单位指标" ? 0 : 6,
      itemStyle: {
        color: EchartsLightColor[i],
      },
      animation: router.currentRoute.path == "/energyReport" ? false : true,
    });
  });

  return option;
}
